import React from 'react';
export const Logo = ({
  size = 'default'
}) => {
  const sizeClasses = size === 'small' ? 'h-6 w-6' : 'h-8 w-8';
  return <div className="flex items-center" data-id="element-164">
      <div className={`relative ${sizeClasses} mr-2 flex-shrink-0`} data-id="element-165">
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full" data-id="element-166">
          {/* Book/Catalog base */}
          <rect x="2" y="6" width="28" height="20" rx="2" fill="#2563EB" data-id="element-167" />
          <rect x="4" y="8" width="24" height="16" rx="1" fill="white" data-id="element-168" />
          {/* Pages */}
          <path d="M16 8V24" stroke="#2563EB" strokeWidth="1" data-id="element-169" />
          {/* Speech bubble */}
          <path d="M20 12C23.3137 12 26 14.6863 26 18C26 19.5913 25.3284 21.0174 24.2426 22C24.7398 23.0615 25.5 24 25.5 24C24 24 22.7398 23.5615 22 23C21.3674 23.3168 20.6326 23.5 19.5 23.5C16.1863 23.5 14 20.8137 14 17.5C14 14.1863 16.6863 12 20 12Z" fill="#2563EB" data-id="element-170" />
        </svg>
      </div>
      <div data-id="element-171">
        <span className="font-bold text-blue-600 text-lg leading-none" data-id="element-172">
          Talking
        </span>
        <span className="font-bold text-gray-700 text-lg leading-none ml-1" data-id="element-173">
          Catalogs
        </span>
      </div>
    </div>;
};